'use strict';

var _ = require('lodash');

module.exports = SelectDirective;

function SelectDirective ($compile, $document, $parse, $templateCache, SelectService) {

  var optionsTpl = $templateCache.get('saturn/form/select/opt.tpl.html');
  var optionsGroupTpl = $templateCache.get('saturn/form/select/optgroup.tpl.html');

  return {
    compile: compile,
    scope: {
      disabled: '@', // {true|false}
      label: '@', // optional label
      placeholder: '@',
      group: '@'
    },
    require: '?ngModel',
    templateUrl: 'saturn/form/select/select.tpl.html',
    controller: ['$injector', '$scope', function($injector, $scope) {
      if ($scope.group) {
        SelectService.register($scope.group, $scope);
      }


    }]
  };

  function compile ($el, attrs) {

    $el.addClass('sb-select');

    if (attrs.label) {
      $el.addClass('has-label');
    }

    return {
      pre: function ($scope, $el) {

        // options will be parsed and used to build the ng-repeat expression
        var optionFns = parseOptionsExp(attrs.options);
        var menuEl = angular.element($el[0].querySelector('.sb-select-menu'));

        // attach search template if needed
        if (!_.isUndefined(attrs.search)) {
          var searchTpl = $templateCache.get('saturn/form/select/search.tpl.html');
          menuEl.append($compile(searchTpl)($scope));
        }

        // attach the options list template
        if (optionFns.groupBy) {
          menuEl.append($compile(optionsGroupTpl)($scope));
        } else {
          menuEl.append($compile(optionsTpl)($scope));
        }
      },
      post: link
    };
  }

  function link ($scope, $el, attrs, ngModelCtrl) {

    ngModelCtrl = ngModelCtrl || mockNgModelCtrl();

    var originalScope = $scope.$parent;

    // optionFns contains the results of parsing the `options` attr expression
    var optionFns = parseOptionsExp(attrs.options);

    _.extend($scope, {
      open: false,
      searchKey: getSearchKey(),
      selectOpt: selectOpt,
      selected: '',
      toggleMenu: toggleMenu,
      onBodyClick: onBodyClick
    });

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    ///////////////////////////////////////////////////////////////////////////////////////////////

    var bodyEl = angular.element($document[0].body);

    // ## Scope Handlers

    // Watch for changes to ngModel viewValue so we can update the view
    $scope.$watch(function () {
      return ngModelCtrl.$viewValue;
    }, function (val, oldVal) {
      if ($scope.options) {
        if (!val || (Array.isArray(val) && !val.length)) {
          deselectAll();
          updateSelected();
        } else if (val !== oldVal) {
          ngModelCtrl.$setDirty();
          selectOptionsFromModelViewValue(val);
        }
      }
    });

    // Re-parse options if the `values` changes
    $scope.$watch(optionFns.valuesFn.bind(null, originalScope),
    function (values, oldValues) {
      if (values !== oldValues) {
        optionFns = parseOptionsExp(attrs.options);
        updateOptions();
      }
    });

    // Re-render the option elements if the option values or labels change
    $scope.$watchCollection(getWatchablesFn(originalScope), updateOptions);
    $scope.$on('$destroy', onDestroy);

    function onDestroy () {
      $el.off('click', onElementClick);
      bodyEl.off('click', onBodyClick);
      if (attrs.group) {
        SelectService.unregister(attrs.group, $scope);
      }
    }

    function updateOptions () {
      var options = getOptions(originalScope);

      if (optionFns.groupBy) {
        $scope.options = getGroups(originalScope, options);
      } else {
        $scope.options = options;
      }

      $scope.$$options = $scope.options; // used for search
      updateSelected();
    }

    // ## UI Handlers

    $el.on('click', onElementClick);
    bodyEl.on('click', onBodyClick);

    function onBodyClick () {
      $scope.$evalAsync(function () {
        closeMenu();
      });
    }

    function onElementClick (e) {
      // toggle off any other select dropdowns that are in the same group
      // this is to prevent a group from having multiple open select dropdowns
      if (attrs.group) {
        SelectService.clicked(attrs.group, $scope);
      }
      // don't allow the event to propogate or it will cause the options menu to close
      e.stopPropagation();
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Helpers
    ///////////////////////////////////////////////////////////////////////////////////////////////

    function closeMenu () {
      $scope.open = false;
    }

    function deselectAll () {
      var options = $scope.options;

      // if grouped... flatten
      if (optionFns.groupBy) {
        options = flattenGroupedOptions(options);
      }

      options.forEach(function (opt) {
        opt.selected = false;
      });
    }

    /**
     * Convenience function to flatten grouped options
     *
     * @param  {Object} options Grouped options
     * @return {Array} Flattened list of options
     */
    function flattenGroupedOptions (options) {
      return _.reduce(options, function (memo, group) {
        return memo.concat(group);
      }, []);
    }

    /**
     * Used when the model value changes externally (i.e. not triggered by `selectOpt`)
     *
     * @param  {*} val ngModel $viewValue
     */
    function selectOptionsFromModelViewValue (val) {

      var options = $scope.options;

      if (isMultiple()) {
        if (!Array.isArray(val)) {
          throw new Error('ngModel.$viewValue must be an array for multi-select');
        }
      } else {
        if (Array.isArray(val)) {
          throw new Error('ngModel.$viewValue must be a string or number for single-select');
        }
      }

      // if grouped... flatten
      if (optionFns.groupBy) {
        options = flattenGroupedOptions(options);
      }

      // deselect everything
      deselectAll();

      if (isMultiple()) {
        val.forEach(function (v) {
          options.forEach(function (opt) {
            if (opt.viewValue === v) {
              opt.selected = true;
            }
          });
        });
      } else {
        options.forEach(function (opt) {
          if (opt.viewValue === val) {
            opt.selected = true;
          }
        });
      }

      updateSelected();
    }

    function isSelected (viewValue) {
      var modelViewValue = ngModelCtrl.$viewValue; // current view value
      if (Array.isArray(modelViewValue)) {
        return !!~_.findIndex(modelViewValue, viewValue);
      } else {
        return _.isEqual(modelViewValue, viewValue);
      }
    }

    function getSearchKey () {
      var parts = optionFns.displayName.split('.');
      return parts[parts.length-1];
    }

    function isMultiple () {
      return attrs.multiple !== undefined && !(/false/gi).test(attrs.multiple);
    }

    function selectOpt (event, opt) {

      if (opt.disabled) {
        return;
      }

      updateViewValue(opt.viewValue);
    }

    function toggleMenu () {
      $scope.open = !$scope.open;
    }

    /**
     * Updates the `selected` value on the $scope
     */
    function updateSelected () {
      var options = $scope.options;
      var arr = $scope.selected && $scope.selected.split(/,\s?/) || [];

      // if grouped... flatten
      if (optionFns.groupBy) {
        options = flattenGroupedOptions(options);
      }

      options.forEach(function (opt) {
        // add to selected if not already present
        var index = arr.indexOf(opt.label);
        if (opt.selected && index === -1) {
          arr.push(opt.label);
        } else if (!opt.selected && index !== -1) {
          arr.splice(index, 1);
        }
      });

      if (isMultiple()) {
        $scope.selected = arr.join(', ');
      }
      else {
        $scope.selected = arr[arr.length-1];
      }
    }

    /**
     * Update the ngModelCtrl viewValue/modelValue when an option is selected/deselected
     * through user interaction.
     *
     * @param  {Object|String|Number} value
     * @return {[type]}       [description]
     */
    function updateViewValue (value) {

      var viewValue = ngModelCtrl.$viewValue; // current view value

      if (!isMultiple()) {

        // update the value
        // check to see if the value is currently selected
        if (isSelected(value)) {
          ngModelCtrl.$setViewValue(null);
        } else {
          ngModelCtrl.$setViewValue(value);
        }

        // close the dropdown
        closeMenu();
      } else {
        viewValue = viewValue && viewValue.slice() || [];
        var index = _.findIndex(viewValue, value);

        // if the value already exists, remove it
        if (!!~index) {
          viewValue.splice(index,1);
        } else {
          if (value) {
            viewValue.push(value);
          }
        }

        if (!viewValue.length) {
          viewValue = null;
        }

        ngModelCtrl.$setViewValue(viewValue);
      }
    }

    function getOptions (scope) {

      var options = [];
      var values = optionFns.valuesFn(scope);

      _.forEach(values, function (val, key) {
        var locals = optionFns.getLocals(val, key);
        var disabled = optionFns.disableWhenFn(scope, locals);
        var group = optionFns.groupByFn(scope, locals);
        var label = optionFns.displayFn(scope, locals);
        var viewValue = optionFns.viewValueFn(scope, locals);
        var selected = isSelected(viewValue);

        // build the options object
        var option = new Option(viewValue, label, group, disabled, selected);
        options.push(option);

        // set selected
        // if (selected) {
        //   updateSelected(option, true);
        // }
      });

      return options;
    }

    function getGroups ($scope, options) {
      if (optionFns.groupBy) {
        return _.groupBy(options, function (opt) {
          return opt.group;
        });
      }
      return null;
    }

    /**
     * Create a collection of things that we would like to watch (watchedArray) so that they can
     * all be watched using a single $watchCollection that only runs the handler once if anything
     * changes
     */
    function getWatchablesFn (scope) {

      var match = optionFns.match;
      var displayFn = optionFns.displayFn;
      var valuesFn = optionFns.valuesFn;
      var getLocals = optionFns.getLocals;
      var disableWhenFn = optionFns.disableWhenFn;
      var values = valuesFn(scope);

      return function () {
        var watchedArray = _.reduce(values, function (watchedArray, value, key) {
          var locals = getLocals(value, key);
          var label = displayFn(scope, locals);

          // Always watch label for change...
          // ngOptions does not actually do this, but I think it makes sense for us
          watchedArray.push(label);

          // Only need to watch the disableWhenFn if there is a specific disable expression
          if (match[4]) {
            var disableWhen = disableWhenFn(scope, locals);
            watchedArray.push(disableWhen);
          }

          return watchedArray;
        }, []);

        return watchedArray;
      };
    }
  }

  /**
   * Parses the "options" expression in order to build the necessary objects.
   *
   * @note Currently "trackBy" is ignored.
   *
   * @param  {[type]} optionsExp [description]
   * @return {[type]}            [description]
   */
  function parseOptionsExp (optionsExp) {

    // REGEX taken from angular ngOptions
    // @see https://github.com/angular/angular.js/blob/master/src/ng/directive/ngOptions.js#L218
    //
    // 1: value expression (valueFn)
    // 2: label expression (displayFn)
    // 3: group by expression (groupByFn)
    // 4: disable when expression (disableWhenFn)
    // 5: array item variable name
    // 6: object item key variable name
    // 7: object item value variable name
    // 8: collection expression
    // 9: track by expression
    var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;

    var match = optionsExp.match(NG_OPTIONS_REGEXP);

    if (!match) {
      throw new Error('Options expression is formatted incorrectly');
    }

    // ## Extract the parts from the ngOptions expression

    // The variable name for the value of the item in the collection
    var valueName = match[5] || match[7];

    // An expression that generates the viewValue for an option if there is a label expression
    var selectAs = / as /.test(match[0]) && match[1];

    var displayName = match[2] || match[1];
    var displayFn = $parse(displayName);

    // An expression that generates the viewValue for an option if there is no label expression
    var valueFn = $parse(match[2] ? match[1] : valueName);
    var selectAsFn = selectAs && $parse(selectAs);
    var viewValueFn = selectAsFn || valueFn;

    // The variable name for the key of the item in the collection
    var keyName = match[6];

    // An expression that is used to track the id of each object in the options collection
    var trackBy = match[9];

    // The variable name for the collection
    var valuesName = match[8];

    var getLocals = (function () {
      var locals = {};

      if (keyName) {
        return function (value, key) {
          locals[keyName] = key;
          locals[valueName] = value;
          return locals;
        };
      } else {
        return function (value) {
          locals[valueName] = value;
          return locals;
        };
      }
    })(keyName, valueName);

    return {
      match: match,
      groupBy: match[3],
      keyName: keyName,
      trackBy: trackBy,
      valueName: valueName,
      valuesName: valuesName,
      displayName: displayName,

      // methods for retrieving the given value from the options collection

      disableWhenFn: $parse(match[4] || ''),
      groupByFn: $parse(match[3] || ''),
      displayFn: displayFn,
      valuesFn: $parse(valuesName),
      viewValueFn: viewValueFn,

      // helper method to construct "locals" object to be used when invoking the $parse.getter
      getLocals: getLocals
    };
  }

  function Option (viewValue, label, group, disabled, selected) {
    // this.selectValue = selectValue;
    this.viewValue = viewValue;
    this.label = label;
    this.group = group;
    this.disabled = disabled;
    this.selected = selected;
  }

  /**
   * Mock ngModelController if it doesn't exist to give us the minimum functionality needed
   */
  function mockNgModelCtrl () {
    return {
      $setViewValue: function(val) {
        this.$viewValue = val;
        this.$viewChangeListeners.forEach(function (cb) {
          cb();
        });
      },
      $setTouched: angular.noop,
      $parsers: [],
      $formatters: [],
      $viewChangeListeners: []
    };
  }
}


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/form/src/select/SelectDirective.js